import * as React from 'react';
import { Img } from 'common--design-library';
import { translationForTiposBoth } from 'easit--localization';

export const Legend: React.FC = () => {
    const t = translationForTiposBoth();
    return <div className={"d-flex flex-column legend mt-3"}>
        <h4>{t.bet_Legend}</h4>
        <div className={"d-flex my-1 align-items-center"}>
            <Img src={"tip_none.gif"} /><div className={"legend-text"}>{t.bet_LegendNotResolvedYet}</div>
        </div>
        <div className={"d-flex my-1 align-items-center"}>
            <Img src={"tip_win.gif"} /><div className={"legend-text"}>{t.bet_LegendWin}</div>
        </div>
        <div className={"d-flex my-1 align-items-center"}>
            <Img src={"tip_loose.gif"} /><div className={"legend-text"}>{t.bet_LegendLost}</div>
        </div>
        <div className={"d-flex my-1 align-items-center"}>
            <Img src={"tip_cancel.gif"} /><div className={"legend-text"}>{t.bet_LegendCanceled}</div>
        </div>
        <div className={"d-flex my-1 align-items-center"}>
            <Img src={"tip_cashout.gif"} /><div className={"legend-text"}>{t.bet_LegendSold}</div>
        </div>
    </div>
}